export const GET_CATEGORY = "GET_CATEGORY";
export const GET_LIST_STORES = "GET_LIST_STORES";
export const GET_LIST_PRODUCTS = "GET_LIST_PRODUCTS";
export const GET_LIST_CONTACTS = "GET_LIST_CONTACTS";
export const LIST_LOADING = "LIST_LOADING";
